export enum AnalyticsConstantsParams {
  // IMPLEMENTATION TEAM
  implementation_team = 'ciclo-de-vida-do-cliente',
}
